// Central constants – import from here so every module uses the same value
export const API = `/api`;

// Odoo shop URLs – sourced from REACT_APP_ODOO_* environment variables
export const ODOO_BASE_URL = process.env.REACT_APP_ODOO_BASE_URL || 'https://www.3dfabrikshop.de';
export const ODOO_ADD_TO_CART_URL = process.env.REACT_APP_ODOO_ADD_TO_CART_URL || 'https://www.3dfabrikshop.de/stl/add_to_cart';
export const ODOO_CART_RETURN_URL = process.env.REACT_APP_ODOO_CART_RETURN_URL || 'https://www.3dfabrikshop.de/shop/cart';
